import { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { BuyMeACoffeeButton } from './BuyMeACoffeeButton';
import './Navigation.css';

export function Navigation() {
  const navRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const nav = navRef.current;
    if (!nav) return;

    const updateNavHeight = () => {
      const height = nav.getBoundingClientRect().height;
      document.documentElement.style.setProperty('--nav-height-mobile', `${height}px`);
    };

    const observer = new ResizeObserver(updateNavHeight);
    observer.observe(nav);
    updateNavHeight();

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <nav className="navigation" ref={navRef}>
        <Link to="/" className="nav-brand">
          <h2>Mythic Forge</h2>
        </Link>
      </nav>
      <BuyMeACoffeeButton />
    </>
  );
}
